import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatPriceWithCurrency } from '../../utils/vat';

/** "Sivun kautta 6 varausta, n. 1 900 € laskutusta tässä kuussa." */
export default function RoiLine({ stats }) {
  const { t } = useTranslation();
  if (!stats) return null;
  const bookings = stats.bookings_this_month ?? 0;
  const revenue = Number(stats.invoiced_this_month || 0);
  return (
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} data-testid="website-roi-line">
      {t('website.roi_line', { bookings, revenue: formatPriceWithCurrency(revenue) })}
    </Typography>
  );
}
